module.exports = __webpack_public_path__ + "img/applymanage.1de08581.svg";